import DATA from "@/lib/scienceRubricData.json";

export const SCIENCE_RUBRICS = {
  science_interest: {
    name: "Rubric A – Science Interest",
    criteria: DATA.science_interest,
    notes: [
      "A contention opposing the 'expected' view is fully acceptable if it is argued consistently with evidence.",
      "Evidence taken from the article must be cited and paraphrased: copying whole sentences caps Criterion 4 at 6.",
      "If a discussion point is missing entirely, cap Criterion 2 at 5 and cap Criterion 3 at 7.",
      "Marks for expression sit inside Criterion 5; do not deduct for handwriting or minor spelling unless meaning is lost.",
    ],
  },
  science_analysis: {
    name: "Rubric B – Science Analysis",
    criteria: DATA.science_analysis,
    notes: [
      "Mark only content from Weeks 1–4. Do not reward or penalise error classification or other later skills.",
      "Reliability needs numbers: a response that only defines the word 'reliable' cannot score above 4 on Criterion 3.",
      "Accuracy needs a true/reference value and precision needs the spread of repeats: reward correct reasoning even if the example differs from the exemplar.",
      "Allow follow-through marks: a correct method applied to an arithmetic slip earns the method marks.",
    ],
  },
};

export const OVERALL_GUIDE = [[45, "Exceptional"], [38, "Strong"], [30, "Competent"], [20, "Developing"], [0, "Needs targeted support"]];
export const guideFor = (total) => (OVERALL_GUIDE.find(([min]) => total >= min) || OVERALL_GUIDE[4])[1];

export const SCIENCE_FEEDBACK_LABELS = { strengths: "Specific praise", improvements: "I think the main piece of feedback that I have is…", comment: "Next step to practise" };
